export default {
  red: "#CC4014",

  orange: "#FF8940",

  green: "#80CC1C",

  yellow: "#F9A602",

  brightBlue: "#00B6FF",

  cornflowerBlue: "#4B6DFF",

  purple: "#A600FF",

  fuschia: "#993D78",

  pink: "#DA6DB3",

  gray: "#C2C2C3"
};



// WEBPACK FOOTER //
// ./src/colors.js